// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2beXl","title":"FrontImage_title__g2F5v"};